import { LoadingButton } from "@mui/lab";
import { Box, FormControl, FormLabel, Grid, TextField } from "@mui/material";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Controller, useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import MainLayout from "../../components/MainLayout";
import ProtectedPermissionPage from "../../components/ProtectedPermissionPage";
import useNotification from "../../hooks/useNotification";
import regionService from "../../services/region";
import queryDefault from "../../utils/queryDefault";

export default function RegionCreate() {
  const notification = useNotification();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const form = useForm({
    defaultValues: {
      name: "",
    },
  });

  const createRegion = useMutation(regionService.createRegion, {
    onSuccess: () => {
      setIsSubmitting(false);
      navigate("/app/region");
      notification.onOpen({
        message: "Region created successfully!",
        type: "success",
        position: "top",
      });
    },
    onError: () => {
      setIsSubmitting(false);
      notification.onOpen({
        message: "Failed to create region",
        type: "error",
        position: "top",
      });
    },
    ...queryDefault,
  });

  const onSubmit = (values: any) => {
    setIsSubmitting(true);
    createRegion.mutate({ name: values.name });
  };

  return (
    <MainLayout>
      <Helmet>
        <title>Create Region</title>
      </Helmet>

      <Breadcrumb
        label="Create Region"
        breadcrumbs={[
          { label: "Dashboard", href: "/app" },
          { label: "Region Management", href: "/app/region" },
        ]}
      />

      <ProtectedPermissionPage acceptPermissions={[1, 2]}>
        <Box sx={{ mt: 3 }}>
          <Grid container>
            <Grid item lg={4} xs={12}>
              <FormControl fullWidth sx={{ mt: 2 }}>
                <FormLabel required>Name</FormLabel>
                <Controller
                  name="name"
                  control={form.control}
                  rules={{ required: "Name is required" }}
                  render={({ field: { ref, ...field }, fieldState }) => (
                    <TextField
                      {...field}
                      inputRef={ref}
                      error={Boolean(fieldState.error?.message)}
                      helperText={fieldState.error?.message}
                      size="small"
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mt: 3 }}>
          <LoadingButton
            variant="contained"
            loading={isSubmitting}
            onClick={form.handleSubmit(onSubmit)}
          >
            Save
          </LoadingButton>
        </Box>
      </ProtectedPermissionPage>
    </MainLayout>
  );
}